export default __webpack_public_path__ + "static/pos2-93b3b7be57e569b487e0cb3c8b099fe1.jpg";